import React from 'react';
import { Box, Text, Flex, Divider } from '@spothero/ui';
import ReservationDuration from 'common/spot-details/reservation-duration';
import { Price } from 'common/facility-summary/price';
import AccessHours from '../access-hours/AccessHours';
import InOut from '../inout/InOut';
const SingleRate = ({ title, onInfoButtonClick, onPriceLabelClick, priceLabel, price, starts, ends, differentDurations, showTotal = false, showPrice = true, selectedRate, facility, isSingleRate = true, }) => {
    return (<Box width="100%" height="100%" data-testid={`single-rate-${title}`}>
            <Flex>
                <Flex>
                    <Text fontSize="sm" fontWeight="semibold" paddingBottom="1" alignItems="center" maxWidth={onInfoButtonClick ? '200px' : 'none'}>
                        {title}
                    </Text>
                </Flex>
                {showPrice && (<Box flexGrow={1} sx={{
                sup: { top: '-0.3em', fontSize: '70%' },
                '& .FacilitySummary-price-container': {
                    flexDirection: showTotal ? 'column' : 'row',
                    justifyContent: 'flex-end',
                    ' & .chakra-text': {
                        color: 'text.primary.light',
                        fontSize: 'base',
                    },
                },
                '& .FacilitySummary-FormattedPrice': {
                    fontSize: 'base',
                    fontWeight: 'semibold',
                },
            }} data-testid="SingleRate-cost-inout">
                        <Price price={price} priceLabel={priceLabel} onShowPriceBreakdown={onPriceLabelClick}/>
                    </Box>)}
            </Flex>
            <AccessHours displayHoursComment={selectedRate?.display_hours_comment} hoursOfOperation={facility?.hours_of_operation} rateAccessHoursFormatted={selectedRate?.access_hours_formatted} facilityAccessHoursFormatted={facility?.access_hours_formatted}/>
            {!isSingleRate && <Divider my={3}/>}
            <InOut inOut={selectedRate?.in_out}/>
            {isSingleRate && <Divider my={3}/>}
            {differentDurations && (<ReservationDuration starts={starts} ends={ends} marginTop="1"/>)}
        </Box>);
};
export default SingleRate;
